import { FormArray, FormControl, FormGroup, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { rmaShareReplay } from '@rma/generic/rxjs/operators/rma-share-replay';
import { filter, isObservable, map, Observable, of, switchMap, tap } from 'rxjs';
import { FormActionTypes, TypedControlsIn, TypedFormGroup } from '../domain';

export class FormHelpers {
  public setInitialValue<FormType>(
    initialValue: Partial<FormType> | Observable<Partial<FormType>>,
    group: TypedFormGroup<FormType, TypedControlsIn<FormType, never, never>>,
  ) {
    if (isObservable(initialValue)) {
      initialValue.subscribe((val) => group.patchValue(val, { emitEvent: false }));
    } else {
      group.patchValue(initialValue, { emitEvent: false });
    }
  }

  public validateAllFormFields<FormType>(group: TypedFormGroup<FormType> | UntypedFormGroup): void {
    Object.keys(group.controls).forEach((field) => {
      const control = group.get(field);
      if (control instanceof UntypedFormControl) {
        control.markAsTouched({ onlySelf: true });
        control.updateValueAndValidity({ onlySelf: false, emitEvent: true });
      } else if (control instanceof UntypedFormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  // this will handle form arrays, stones will come and clean it up

  // public validateAllFormFields(control: AbstractControl): void {
  //   if (control instanceof UntypedFormControl) {
  //     control.markAsTouched({ onlySelf: true });
  //     control.updateValueAndValidity({ onlySelf: false, emitEvent: true });
  //   } else if (control instanceof UntypedFormGroup) {
  //     Object.keys(control.controls).forEach((field) => {
  //       this.validateAllFormFields(control.get(field));
  //     });
  //   } else if (control instanceof UntypedFormArray) {
  //     for (let i = 0; i < control.controls.length; i++) {
  //       this.validateAllFormFields(control.controls[i]);
  //     }
  //   }
  // }

  public getFormSubmitTypeStreams<FormType>(actions$: Observable<FormActionTypes>, group: TypedFormGroup<FormType>) {
    const attemptSubmit$ = actions$.pipe(
      filter((action) => action === FormActionTypes.ValidateAndSubmit),
      tap(() => this.validateAllFormFields(group)),
      switchMap(() => of(group.valid)),
      rmaShareReplay(),
    );

    return {
      valid$: attemptSubmit$.pipe(filter((status) => status)),
      nonValid$: attemptSubmit$.pipe(
        filter((status) => !status),
        map(() => true),
      ),
    };
  }
}

/**
 * Moves an item in a FormArray to another position.
 * @param formArray FormArray instance in which to move the item.
 * @param fromIndex Starting index of the item.
 * @param toIndex Index to which he item should be moved.
 */

export function moveItemInFormArray(formArray: FormArray, fromIndex: number, toIndex: number): void {
  const dir = toIndex > fromIndex ? 1 : -1;

  const item = formArray.at(fromIndex);
  for (let i = fromIndex; i * dir < toIndex * dir; i = i + dir) {
    const current = formArray.at(i + dir);
    formArray.setControl(i, current);
  }
  formArray.setControl(toIndex, item);
}

export function validateAllFormFields(form: FormGroup): void {
  Object.keys(form.controls).forEach((field) => {
    const control = form.get(field);
    if (control instanceof FormControl) {
      control.markAsTouched({ onlySelf: true });
      control.updateValueAndValidity({ onlySelf: false, emitEvent: true });
    } else if (control instanceof FormGroup) {
      validateAllFormFields(control);
    }
  });
}

export interface FormValueConfig {
  onlySelf?: boolean;
  emitEvent?: boolean;
}
